<ps-ui-card>
  <h6 psCardHeader>FIELDED VS. GOAL</h6>
  <p psCardContent class="fielded-content">
    {{ content.fielded | number }} | {{ content.goal | number }}
  </p>
  <p class="fielded-content-footer" psCardFooter>
    Net of
    {{ content.reconciliationCompleteCount + content.manualFixCompltCount }}
    adjustments
    <span class="help-tip">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <p>
        Net Number of completes that have been Manually Fixed: <br />
        {{ content.manualFixCompltCount }} <br />Net Number of completes that
        have been Buyer Reconciled : <br />{{
          content.reconciliationCompleteCount
        }}
      </p>
    </span>
  </p>
</ps-ui-card>
